import axios from '@fs/zion-axios'

// We don't want to reload on 401 in this case
const axiosInstance = axios.create()

const BASE_USER_PREFERENCES_PATH = '/service/cmn/user-preferences/users'

export async function getUserPreferredRole(userId) {
  const response = axiosInstance.get(`${BASE_USER_PREFERENCES_PATH}/${userId}/preferences/data.dmc.role`)
  return response
}

export async function setUserPreferredRole(userPreferredRole, userId) {
  const requestBody = {
    value: userPreferredRole,
  }
  const response = await axiosInstance.put(
    `${BASE_USER_PREFERENCES_PATH}/${userId}/preferences/data.dmc.role`,
    requestBody
  )
  return response
}
